import React from 'react'
import Dropzone from 'react-dropzone'
import { uploadDataFromExcel } from '../helpers'

const MuiDropzone = props => {
  const { existingItems, fieldMappings, path, children, onComplete } = props
  return (
    <Dropzone
      multiple={false}
      disableClick
      style={{}}
      onDrop={async files => {
        const uploaded = await uploadDataFromExcel(
          files,
          existingItems,
          fieldMappings,
          path
        )
        onComplete(uploaded)
      }}
    >
      {children}
    </Dropzone>
  )
}

export default MuiDropzone



// WEBPACK FOOTER //
// ./src/core/components/Dropzone.js